import HNSColors from "../../../../ui library/HNSColors";

const RADIAN = Math.PI / 180;

export const formatFeeScheduleCurrency = (value) => `$${Number(value || 0).toFixed(2)}`;

export const getFeeScheduleValues = ({ caseDetail, feeSchedule }) => {
  const rawSettlementAmount = caseDetail?.actualTotalSettlementAmount;

  return {
    rawSettlementAmount,
    settlementAmount: rawSettlementAmount ?? 0,
    isFeeScheduleUnavailable: rawSettlementAmount === null || rawSettlementAmount === undefined,
    grossDeductions: feeSchedule?.gross_deductions ?? 0,
    otherDeductions: feeSchedule?.total_deductions ?? 0,
    attorneyFees: feeSchedule?.law_fees ?? 0,
    medicalFees: feeSchedule?.medical_fees ?? 0,
    clientPayout: feeSchedule?.client_payout ?? 0,
    otherDeductionsPercentage: feeSchedule?.deduction_percentage ?? 0,
    attorneyFeesPercentage: feeSchedule?.law_firm_percentage ?? 0,
    medicalFeesPercentage: feeSchedule?.medical_percentage ?? 0,
    clientPayoutPercentage: feeSchedule?.client_percentage ?? 0,
    netToClient: feeSchedule?.net_to_client ?? 0,
  };
};

export const getFeeScheduleChartColors = () => ({
  otherDeductions: HNSColors.secondary[400],
  attorneyFees: HNSColors.secondary[500],
  medicalFees: HNSColors.secondary[600],
  clientPayout: HNSColors.secondary[800],
});

export const getFeeScheduleChartData = (values, colors) => {
  const chartData = [
    {
      name: "Other Deductions",
      value: Number(values.otherDeductionsPercentage || 0),
      color: colors.otherDeductions,
    },
    {
      name: "Attorney's Fees",
      value: Number(values.attorneyFeesPercentage || 0),
      color: colors.attorneyFees,
    },
    {
      name: "Medical Fees + Fees",
      value: Number(values.medicalFeesPercentage || 0),
      color: colors.medicalFees,
    },
    {
      name: "Client Payout",
      value: Number(values.clientPayoutPercentage || 0),
      color: colors.clientPayout,
    },
  ].filter((item) => item.value > 0);

  return chartData.length
    ? chartData
    : [{ name: "No Data", value: 1, color: HNSColors.tertiary[800] }];
};

export const getActiveTooltipPosition = (data, activeName) => {
  if (!activeName || !data.length) {
    return undefined;
  }

  const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);
  const activeIndex = data.findIndex((item) => item.name === activeName);

  if (!total || activeIndex === -1) {
    return undefined;
  }

  const cx = 110;
  const cy = 90;
  const outerRadius = 72;
  const paddingAngle = 2;
  let currentAngle = -90;

  for (let index = 0; index < data.length; index += 1) {
    const sliceAngle = (Number(data[index].value || 0) / total) * 360;

    if (index === activeIndex) {
      const midAngle = currentAngle + sliceAngle / 2;
      const anchorX = cx + Math.cos(-midAngle * RADIAN) * (outerRadius + 12);
      const anchorY = cy + Math.sin(-midAngle * RADIAN) * (outerRadius + 12);

      return { x: anchorX, y: anchorY };
    }

    currentAngle += sliceAngle + paddingAngle;
  }

  return undefined;
};
